import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=cfa84b96&scoped=true"
import script from "./settings.vue?vue&type=script&lang=ts&setup=true"
export * from "./settings.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./settings.vue?vue&type=style&index=0&id=cfa84b96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa84b96",
  null
  
)

export default component.exports